(function () {
  'use strict';

  var ECF_ENDPOINT = 'https://ecf.cirkleinc.com/api/form-submit';

  /**
   * @param {HTMLFormElement} form
   * @param {boolean} isLoading
   */
  function setFormLoading(form, isLoading) {
    var submitBtn = form.querySelector('button[type="submit"]');
    if (!(submitBtn instanceof HTMLButtonElement)) return;
    submitBtn.disabled = isLoading;
    submitBtn.classList.toggle('is-loading', isLoading);
  }

  /**
   * @param {HTMLFormElement} form
   */
  function bindForm(form) {
    if (!(form instanceof HTMLFormElement)) return;
    if (form.dataset.ugTwnBound === '1') return;
    form.dataset.ugTwnBound = '1';

    var emailInput = form.querySelector('input[type="email"]');
    var checkbox = form.querySelector('input[type="checkbox"]');
    var successMessage = form.querySelector('[data-message="success"]');
    var errorMessage = form.querySelector('[data-message="error"]');
    var defaultSuccess = form.dataset.successMessage || '';
    var defaultError = form.dataset.errorMessage || '';
    var termsError = form.dataset.termsError || 'Bitte akzeptiere die Teilnahmebedingungen.';

    function hideMessages() {
      if (successMessage instanceof HTMLElement) successMessage.hidden = true;
      if (errorMessage instanceof HTMLElement) errorMessage.hidden = true;
    }

    /**
     * @param {HTMLElement | null} target
     * @param {string} text
     */
    function showMessage(target, text) {
      if (!(target instanceof HTMLElement)) return;
      target.hidden = false;
      target.textContent = text;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      hideMessages();

      var emailValue = emailInput instanceof HTMLInputElement ? emailInput.value.trim() : '';

      if (!emailValue) {
        showMessage(errorMessage, defaultError || 'Bitte gib eine gültige E-Mail-Adresse ein.');
        if (emailInput instanceof HTMLInputElement) emailInput.focus();
        return;
      }

      if (checkbox instanceof HTMLInputElement && !checkbox.checked) {
        showMessage(errorMessage, termsError);
        checkbox.focus();
        return;
      }

      setFormLoading(form, true);

      var payload = {
        email: emailValue,
        accepts_marketing: checkbox instanceof HTMLInputElement && checkbox.checked ? 'on' : 'off',
        form_id: form.dataset.formId || ''
      };

      var ecfTag = String(form.dataset.ecfTag || '').trim();
      if (ecfTag) payload.tag = ecfTag;

      fetch(ECF_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data && data.status === 'success') {
            if (emailInput instanceof HTMLInputElement) emailInput.value = '';
            if (checkbox instanceof HTMLInputElement) checkbox.checked = false;
            showMessage(successMessage, defaultSuccess || data.message || 'Danke! Deine Anmeldung wurde erfasst.');
            return;
          }

          var apiError =
            (data && data.errors && data.errors.email && data.errors.email[0]) ||
            (data && data.message) ||
            defaultError ||
            'Anmeldung fehlgeschlagen. Bitte versuche es später erneut.';
          showMessage(errorMessage, apiError);
        })
        .catch(function (err) {
          console.error('UG Terra Wortmann Open ECF error:', err);
          showMessage(
            errorMessage,
            defaultError || 'Anmeldung fehlgeschlagen. Bitte versuche es später erneut.'
          );
        })
        .finally(function () {
          setFormLoading(form, false);
        });
    });
  }

  /**
   * @param {HTMLElement} product
   */
  function bindGiveawayProductScale(product) {
    if (product.dataset.ugTwnScaleBound === '1') return;
    product.dataset.ugTwnScaleBound = '1';

    var card = product.closest('.ug-twn-giveaway-card');
    if (!(card instanceof HTMLElement)) return;

    if (window.matchMedia('(max-width: 1023.98px)').matches) {
      product.style.setProperty('--ug-twn-giveaway-product-scale', '1');
      return;
    }

    var win = /** @type {Window & { gsap?: any, ScrollTrigger?: unknown }} */ (window);

    if (!win.gsap || !win.ScrollTrigger) {
      product.style.setProperty('--ug-twn-giveaway-product-scale', '1');
      return;
    }

    win.gsap.registerPlugin(win.ScrollTrigger);
    win.gsap.fromTo(
      product,
      { '--ug-twn-giveaway-product-scale': 0.72 },
      {
        '--ug-twn-giveaway-product-scale': 1,
        duration: 0.8,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: card,
          start: 'top 65%',
          once: true
        }
      }
    );
  }

  /**
   * @param {Element} root
   */
  function bindSection(root) {
    if (!root) return;
    root.querySelectorAll('.ug-twn-form').forEach(bindForm);
    root.querySelectorAll('[data-twn-giveaway-product]').forEach(function (product) {
      if (product instanceof HTMLElement) bindGiveawayProductScale(product);
    });
  }

  function init() {
    document.querySelectorAll('[data-ug-terra-wortmann-open]').forEach(bindSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!(event.target instanceof Element)) return;
    event.target.querySelectorAll('[data-ug-terra-wortmann-open]').forEach(bindSection);
  });
})();
